import { Box, CssBaseline, CssVarsProvider, Typography } from "@mui/joy";
import EmployeeSidebar from "../components/EmployeeSidebar";
import ReportsTable from "../components/Reports/ReportsTable";
import BtsReportsTable from "./BtsReportsTable";
import { ThemeProvider, createTheme } from "@mui/material/styles";
const theme = createTheme();
const BtsReports = () => {
    return (
        <ThemeProvider theme={theme}>
            <CssVarsProvider disableTransitionOnChange>
                <CssBaseline />
                <Box sx={{ display: "flex", minHeight: "92dvh", background: 'white' }}>
                    <EmployeeSidebar />
                    <Box
                        component="main"
                        className="MainContent"
                        sx={{
                            px: { xs: 2, md: 6 },
                            pt: {
                                xs: "calc(12px + var(--Header-height))",
                                sm: "calc(12px + var(--Header-height))",
                                md: 3,
                            },
                            pb: { xs: 2, sm: 2, md: 3 },
                            flex: 1,
                            display: "flex",
                            flexDirection: "column",
                            minWidth: 0,
                            height: "92dvh",
                            gap: 1,
                        }}
                    >
                        <Box
                            sx={{
                                display: "flex",
                                mb: 1,
                                gap: 1,
                                flexDirection: { xs: "column", sm: "row" },
                                alignItems: { xs: "start", sm: "center" },
                                flexWrap: "wrap",
                                justifyContent: "space-between",
                            }}
                        >
                            <Typography level="h2" component="h1" className="heading-2" sx={{ fontSize: '20px !important' }}>
                                BTS Reports
                            </Typography>
                        </Box>
                        <BtsReportsTable />
                    </Box>
                </Box>
            </CssVarsProvider>
        </ThemeProvider>
    );
};

export default BtsReports;
